export default {
	address2: {
		ajto: '',
		emelet: '',
		epulet: '',
		hsz: '',
		irsz: '',
		kozTerulet: '',
		kozTeruletJellege: '',
		lhaz: '',
		varos: '',
		varosResz: ''
	},
	bankNumber: [],
	fullTaxNumber: '',
	ebizPartner: false,
	lastElement: true,
	name: 'A cég nem szerepel a listában',
	Name: 'A cég nem szerepel a listában',
	regNumber: '',
	registryNumber: '',
	shortName: 'ZZZZZZ',
	showName: 'A cég nem szerepel a listában',
	shortTaxNumber: '',
	notOpten: true
};
